module.exports = __webpack_public_path__ + "img/icon-wechat.4bcadc47.png";